import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = (isExternalOperator) => {
  const privateCustomerData = isExternalOperator
    ? ''
    : `
      lastName
      middleName
      gender
      birthdate
      accounts {
        id
        provider
        providerId
      }
    `;
  return gql`
  query Activity($activityId: ID!) {
    activity(id: $activityId) {
      id
      channelType
      duration
      avatarUrl
      case {
        id
        name
        comment
      }
      team {
        visibleCasesCount
      }
      customer {
        ${privateCustomerData}
        id
        firstName
        vip
        description
        identified
        customInfo {
          label
          value
        }
      }
      messages {
        id
        body
        avatarUrl
        activityId
        insertedAt
        sender
        isRead
        receiver
        to
        from
        copies
        auto
        attachments {
          title
          type
          size
          original
          preview
          ext
        }
      }
    }
  }`;
};

function parse(item) {
  let customerType;
  if (item.customer.identified) {
    customerType = item.channelType;
    if (item.channelType === 'web') customerType = 'client';
  } else {
    customerType = 'anon';
  }
  return {
    ...item,
    type: item.channelType,
    caseId: item.case.id,
    avatarUrl: item.avatarUrl,
    customer: {
      ...item.customer,
      name: item.customer.firstName,
      type: item.customer.identified ? 'client' : 'anon',
    },
    messages: item.messages.map((message) => ({
      ...message,
      username: '',
      customerType,
    })), // TODO username поле убралось
  };
}

export default function getActivityClientCard(activityId, isExternalOperator = false) {
  return apollo.client.query({
    query: query(isExternalOperator),
    variables: { activityId },
    fetchPolicy: 'network-only',
  }).then((res) => parse(res.data.activity));
}
